/* ================================================================
 * v8 by xdf(xudafeng[at]126.com)
 *
 * first created at : Tue Jun 30 2015 23:32:56 GMT+0800 (CST)
 *
 * ================================================================
 * Copyright  xdf
 *
 * Licensed under the MIT License
 * You may not use this file except in compliance with the License.
 *
 * ================================================================ */

'use strict';

module.exports = require('./lib/v8');
